var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.configImageSrc)?_c('div',[(_vm.imageLoaded)?_c('img',{attrs:{"src":_vm.configImageSrc},on:{"error":function($event){_vm.imageLoaded = false}}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.dummyImage)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }